// extracted by mini-css-extract-plugin
module.exports = {"toggler":"Collapsible_toggler__1no_E","header":"Collapsible_header__23BzC"};